// extracted by mini-css-extract-plugin
module.exports = {"root":"EventSponsors_root__OKNhv","submitButton":"EventSponsors_submitButton__lKEod"};